import { Loader2 } from "lucide-react"

export function AddressFormSkeleton() {
  return (
    <section className='rounded-2xl border bg-zinc-100 p-6 shadow-xs md:p-8'>
      <div className='flex min-h-150 max-w-3xl items-center justify-center'>
        <div className='flex flex-col items-center gap-3 text-center'>
          <Loader2 className='size-8 animate-spin text-muted-foreground' />
          <div className='space-y-1'>
            <p className='font-medium text-base text-foreground'>
              Carregando endereco...
            </p>
            <p className='text-muted-foreground text-sm'>
              Um momento, estamos buscando seus dados
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
